<map-loading-overlay [loading]="mapDataIsLoading()" />

<ev-salesmap-layout>
    <div slot="left-menu" class="left-menu-base">
        @if(selectedSale() != null && selectedSale().unitId != 0) {
        <estate-sale-infocard [selectedSale]="miniInfocardEstate()" [imagePackages]="miniInfocardEstateImagePackages()"></estate-sale-infocard>
        } 
        @else if (sales != null && sales?.length === 0) {
        <div class="empty-list">
            <div class="info-icon"></div>
            <div class="header">Ingen treff</div>
            <div class="instruction">Gjør et generelt søk, juster på filtre eller zoom i kart</div>
        </div>
        }

        <estate-sales-list [sales]="sales" [ngClass]="{ 'no-display': selectedSale() != null && selectedSale().unitId != 0 }"></estate-sales-list>
    </div>
    <div slot="right-menu-buttons">
        <map-right-menu-buttons [visibleButtons]="[rightSidebarOptions.Filter, rightSidebarOptions.AreaBuilder, rightSidebarOptions.Statistics, rightSidebarOptions.Favorites]" [canShowFreedrawButtons]="true"></map-right-menu-buttons>
    </div>
    <div slot="right-menu" class="right-menu">
        @if (selectedSidebar() === rightSidebarOptions.Filter) {
            <estate-filter></estate-filter>
        }
        @else if (selectedSidebar() === rightSidebarOptions.AreaBuilder) {
            <area-builder-sidebar-v2 [defaultAreaStructure] = "currentAreaStructure"></area-builder-sidebar-v2>
        }
        @else if (selectedSidebar() === rightSidebarOptions.Statistics) {
            <div class="statistics">
                <estate-statistics [statistics]="statistics" [estateAgentMarketShares]="estateAgentMarketShares"></estate-statistics>
            </div>
        }
            @else if (selectedSidebar() === rightSidebarOptions.Favorites) {
            <div class="statistics">
                <estate-favorite-lists [sales]="sales"></estate-favorite-lists>
            </div>
        }
    </div>
</ev-salesmap-layout>
